// Define filter condition types
export type FilterCondition =
  | string
  | number
  | boolean
  | null
  | { [key: string]: FilterCondition }
  | { $ilike: string }
  | FilterCondition[];

export const serializeSort = (
  field: string,
  direction: 'ASC' | 'DESC',
): string => {
  return `${field}:${direction}`;
};

// Helper function to build filter strings
export const buildFilterString = (
  conditions: Record<string, FilterCondition>,
): string => {
  const stringifyValue = (value: FilterCondition): string => {
    if (Array.isArray(value)) {
      if (value.length === 0) return '[]';
      if (typeof value[0] === 'object' && value[0] !== null) {
        return `[${value.map((v) => stringifyValue(v)).join(',')}]`;
      }
      return `[${value.map((v) => `"${v}"`).join(',')}]`;
    }
    if (typeof value === 'object' && value !== null) {
      if (value.$ilike !== undefined) {
        return `{"$ilike":"${value.$ilike}"}`;
      }
      const parts = Object.entries(value).map(([key, val]) => {
        return `"${key}":${stringifyValue(val)}`;
      });
      return `{${parts.join(',')}}`;
    }
    if (typeof value === 'boolean') {
      return `${value}`;
    }
    if (typeof value === 'number') {
      return `${value}`;
    }
    if (value === null) {
      return 'null';
    }
    return `"${value}"`;
  };

  const parts = Object.entries(conditions).map(([key, value]) => {
    if (key === '$or' || key === '$and') {
      const conditionsArray = Array.isArray(value) ? value : [value];
      const conditionStrings = conditionsArray.map((cond) => {
        return stringifyValue(cond);
      });
      return `"${key}":[${conditionStrings.join(',')}]`;
    }

    return `"${key}":${stringifyValue(value)}`;
  });

  return `${parts.join(',')}`;
};
